// Service Worker registration + graceful update flow.
// Instead of forcing immediate skipWaiting (which reloads the app mid-work),
// we surface a "waiting" registration to the UI via a custom event so the
// user can choose when to refresh.

let refreshing = false;

function notifyWaiting(registration) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent("sw-update-available", { detail: { registration } }),
  );
}

function trackInstallingWorker(registration) {
  const installing = registration.installing;
  if (!installing) return;
  installing.addEventListener("statechange", () => {
    if (installing.state === "installed" && navigator.serviceWorker.controller) {
      // A new SW has finished installing and is now waiting — controller is
      // still the previous SW, so the app is not disrupted. Prompt the user.
      notifyWaiting(registration);
    }
  });
}

export function registerServiceWorker() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;
  if (process.env.NODE_ENV === "development") {
    // Skip SW in dev to avoid caching issues with HMR
    return;
  }

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((reg) => {
        // First-load case: an update was already sitting in the "waiting" slot
        // (e.g. user reloaded after a background update). Surface it.
        if (reg.waiting && navigator.serviceWorker.controller) {
          notifyWaiting(reg);
        }

        reg.addEventListener("updatefound", () => trackInstallingWorker(reg));

        if (reg.update) {
          // Periodic check for newly deployed builds while the tab is open
          setInterval(() => reg.update().catch(() => {}), 60 * 60 * 1000);
        }
      })
      .catch((err) => {
        console.warn("SW registration failed:", err);
      });

    // When the new SW takes control (after it processes SKIP_WAITING),
    // reload once so the user gets the fresh build.
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (refreshing) return;
      refreshing = true;
      window.location.reload();
    });
  });
}

// Called by the update banner when the user clicks "Refresh".
export function applyServiceWorkerUpdate(registration) {
  if (!registration || !registration.waiting) return;
  registration.waiting.postMessage({ type: "SKIP_WAITING" });
}
